import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Typography } from '@material-ui/core';

import CustomButton from "../../Common/CustomButton";
import CloseIcon from "../../Common/CloseIcon";
import colors from "../../../assets/style/colors";

const styles = {
  dialog: {
    width: "350px",
    padding: "12px",
  },
  radio: {
    '&$checked': {
      color: '#0894a4'
    }
  },
  checked: {},
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  content: {
    padding: "24px 12px 12px",
  },
};

const DeleteOccurrence = (props) => {
  const { classes, deleteSchedule, openstate } = props;
  const [open, setOpen] = React.useState(openstate);

  const [value, setValue] = React.useState('thisoccurrenceonly');

  const handleRadio = (event) => {
    setValue(event.target.value);
  };

  return (
    <>
      <Grid item xs style={{ textAlign: "right" }}>
        <CustomButton
          style={{
            color: colors.errorRed,
          }}
          onClick={() => setOpen(true)}
        >
          {I18n.get("delete")}
        </CustomButton>
      </Grid>
      <Dialog open={open} classes={{ paper: classes.dialog }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs />
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="column" className={classes.content}>
              <Grid item>{I18n.get("scheduler_deactivateConfirm")}</Grid>
              <Grid item>
                <br></br>
                <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleRadio} >
                  <FormControlLabel value="thisoccurrenceonly" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("this_occurrence_only")}</Typography>} />
                  <FormControlLabel value="futureoccurrences" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("future_occurrences")}</Typography>} />
                </RadioGroup>
                <Grid container justify="center" style={{ marginTop: "40px" }}>
                  <Grid item style={{ marginRight: "15px" }}>
                    <CustomButton
                      color="primary"
                      onClick={() => setOpen(false)}
                    >
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "15px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      onClick={() => { deleteSchedule(value) }}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(DeleteOccurrence);
